import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

const FilterLevelThirdSelect = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.multiLocation.availableFilters.level_3);
  const selectedOptions = useSelector((state) => state.multiLocation.selectedLevelThird);

  const title = useSelector((state) => state.multiLocation.availableFilters.filter_titles[2]);

  const thirdLevelFiltersLoading = useSelector(
    (state) => state.multiLocation.thirdLevelFiltersLoading
  );

  return thirdLevelFiltersLoading ? (
    <LoadingAnimation uiLoader />
  ) : (
    <>
      <p>{title}</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOptions}
        placeholder="Please Select"
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        onSelectChange={(data) =>
          dispatch(actionCreators.updateFiltersRequest({ name: "FilterLevelThird", data: data }))
        }
      />
    </>
  );
};

export default FilterLevelThirdSelect;
